
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 3.546a.725.725 0 011.025 0L17.5 10.02l-6.475 6.475A.725.725 0 1110 15.471l4.726-4.726H3.225a.725.725 0 110-1.449h11.5L10 4.571a.725.725 0 010-1.025z","fill":"currentColor"}})])
          )
        }
      }
    